import './OutlineCard.css';


const Outlinecard=(props)=>{
    return(
        <div className="card">{props.children}</div>
    );
    
}
export default Outlinecard;